module.exports = __webpack_public_path__ + "assets/icons/account-eye-916a.svg";